import apiClient from "./apiClient";

const projects = [
  {
    id: 1,
    title: 'AgriCart',
    description: 'A full-stack agricultural spare parts shopping platform.',
    image: '1.png',
    features: [
      'Dynamic category and brand-based filtering',
      'User-friendly cart and checkout system',
      'Real-time stock management with MySQL',
      'Mobile-first responsive design',
    ],
    highlights: [
      'Boosted sales by 40% within 3 months',
      'Integrated secure online payment gateway',
      'SEO optimized for organic traffic growth',
    ],
    technologies: ['React.js', 'Spring Boot', 'MySQL', 'Docker', 'Bootstrap'],
    showOnHome: true,
  },
  {
    id: 2,
    title: 'StockWise',
    description: 'Smart inventory system for small-scale manufacturers.',
    image: '2.jpg',
    features: [
      'Automated stock level alerts',
      'Supplier and purchase order management',
      'Custom reporting dashboards',
      'Role-based access control',
    ],
    highlights: [
      'Reduced stock wastage by 30%',
      'Improved operational efficiency with automation',
    ],
    technologies: ['React.js', 'Node.js', 'MongoDB', 'Express.js'],
    showOnHome: true,
  },
  {
    id: 3,
    title: 'FleetIQ',
    description: 'Advanced logistics management with real-time tracking.',
    image: '3.jpg',
    features: [
      'Real-time GPS tracking of fleets',
      'Route optimization with Google Maps API',
      'Automated driver performance reports',
      'Live notifications for delays and updates',
    ],
    highlights: [
      'Cut logistics costs by 20%',
      'Improved delivery accuracy and on-time rate',
    ],
    technologies: ['Angular', 'Spring Boot', 'PostgreSQL', 'AWS'],
    showOnHome: true,
  },
  {
    id: 4,
    title: 'TalentSphere',
    description: 'A human resource portal for employee lifecycle management.',
    image: '4.jpg',
    features: [
      'Employee onboarding and exit management',
      'Leave and attendance tracking',
      'Performance appraisal system',
      'Self-service employee portal',
    ],
    highlights: [
      'Streamlined HR processes by 50%',
      'Paperless document management system',
    ],
    technologies: ['React.js', 'Spring Boot', 'Oracle', 'Keycloak'],
    showOnHome: false,
  },
  {
    id: 5,
    title: 'LeadConnect',
    description: 'Dealer management with customer insights and lead tracking.',
    image: '5.jpg',
    features: [
      'Lead tracking and follow-up automation',
      'Customer communication history logs',
      'Real-time sales performance analytics',
      'Integration with WhatsApp and Email',
    ],
    highlights: [
      'Improved lead conversion by 35%',
      'Centralized platform for dealer communication',
    ],
    technologies: ['Vue.js', 'Laravel', 'MySQL', 'Redis'],
    showOnHome: false,
  },
  {
    id: 6,
    title: 'EduCraft',
    description: 'Custom-built CMS tailored for educational institutions.',
    image: '6.jpg',
    features: [
      'Dynamic content creation and editing',
      'Multi-level admin access',
      'SEO tools built-in',
      'Analytics and reporting dashboard',
    ],
    highlights: [
      'Enabled 50+ institutions to go digital',
      'User-friendly UI for non-technical staff',
    ],
    technologies: ['Next.js', 'Node.js', 'MongoDB', 'TailwindCSS'],
    showOnHome: false,
  },
  {
    id: 7,
    title: 'EduFlex',
    description: 'Comprehensive platform for managing schools with online exams.',
    image: '7.jpg',
    features: [
      'Student and teacher management',
      'Online examination and result generation',
      'Attendance and timetable management',
      'Parent-teacher communication portal',
    ],
    highlights: [
      'Streamlined administration for multiple schools',
      'Enhanced student performance tracking',
    ],
    technologies: ['React.js', 'Spring Boot', 'MySQL', 'Bootstrap'],
    showOnHome: false,
  },
  {
    id: 8,
    title: 'StorePro',
    description: 'Retail store management solution with inventory and billing.',
    image: '8.jpg',
    features: [
      'Inventory and stock control',
      'Billing and invoice generation',
      'Supplier and purchase order management',
      'Sales and reporting dashboards',
    ],
    highlights: [
      'Reduced billing errors by 80%',
      'Optimized stock management',
    ],
    technologies: ['Angular', 'Node.js', 'MongoDB', 'Express.js'],
    showOnHome: true,
  },
  {
    id: 9,
    title: 'MediTrack',
    description: 'Healthcare management platform for pathology labs and pharmacies.',
    image: '9.jpg',
    features: [
      'Patient registration and report management',
      'Lab test tracking and billing',
      'Pharmacy inventory management',
      'Doctor and lab staff portal',
    ],
    highlights: [
      'Enhanced patient service efficiency',
      'Integrated billing and lab reporting',
    ],
    technologies: ['React.js', 'Laravel', 'MySQL', 'TailwindCSS'],
    showOnHome: true,
  },
  {
    id: 10,
    title: 'Enterprise360',
    description: 'Enterprise resource planning system for mid to large organizations.',
    image: '10.jpg',
    features: [
      'Finance, HR, and inventory modules',
      'Workflow automation',
      'Customizable dashboards and analytics',
      'Role-based access control',
    ],
    highlights: [
      'Improved organizational efficiency by 40%',
      'Reduced manual workload across departments',
    ],
    technologies: ['React.js', 'Spring Boot', 'Oracle', 'Docker'],
    showOnHome: true,
  },
  {
    id: 11,
    title: 'FleetMaster',
    description: 'Platform for monitoring and optimizing fleet operations.',
    image: '11.jpg',
    features: [
      'Real-time vehicle tracking and route optimization',
      'Fuel and maintenance tracking',
      'Driver performance monitoring',
      'Reports and alerts for fleet management',
    ],
    highlights: [
      'Reduced operational costs by 25%',
      'Improved fleet utilization and delivery accuracy',
    ],
    technologies: ['Angular', 'Spring Boot', 'PostgreSQL', 'AWS'],
    showOnHome: false,
  },
  {
    id: 12,
    title: 'MoveSmart',
    description: 'End-to-end solution for moving and packing service providers.',
    image: '12.jpg',
    features: [
      'Booking and shipment tracking',
      'Inventory and packing management',
      'Customer notifications and alerts',
      'Billing and payment integration',
    ],
    highlights: [
      'Enhanced customer satisfaction with real-time tracking',
      'Optimized packing and moving operations',
    ],
    technologies: ['Vue.js', 'Node.js', 'MongoDB', 'Bootstrap'],
    showOnHome: false,
  },
];


export const getProjects = async () => {
  try {
    const response = await apiClient.get("/projects");
    return response.data;
  } catch (error) {
      console.error("Error fetching projects:", error);
      //throw error; // rethrow so component can handle it
      return projects;
  }
};

export const getProjectById = async (id) => {
  try {
    const response = await apiClient.get(`/projects/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Failed to fetch project with id ${id}:`, error);
    //throw error; // rethrow so component can handle it
    return projects[id-1];
  }
};
